import React, { useState, useEffect, useContext } from "react";

import styled from "styled-components";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import Chip from "@mui/material/Chip";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import { action as actionVar } from "variables/action";
import { targetedusageList } from "variables/lists/action";
import { ActionContext } from "context/ActionContext";
import {
  AutocompleteMultiselectCheckbox,
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const RTTargetFluid = ({ planActionId, planActionName }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    console.log("useEffect gridState.data");
    setNewData(gridState.data);
  }, [gridState.data]);

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }
  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
    },
    {
      name: "Consommation considérée (MWh ou m3)",
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar.impact.observations}
            intInput={newData[indexFinder(row.id)].value}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="value"
          />
        ) : (
          row.value
        ),
    },
    {
      name: actionVar.impact.targetedusage,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <MultiselectCheckbox
            selected={
              newData.find((obj) => obj.id === row.id)?.targetedusage || []
            }
            list={targetedusageList[row.id]}
            handleChange={(_, e) =>
              handleCheckboxChange(e, "targetedusage", row.id)
            }
            primary=" Consommation totale"
          />
        ) : (
          <GroupCell>
            {newData
              .find((obj) => obj.id === row.id)
              ?.targetedusage?.map((usage) => {
                return <Chip label={usage.name} key={usage.id} />;
              })}
          </GroupCell>
        ),
    },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer">
              <Button
                onClick={editEnabled(row)}
                color={editableRowId === row.id ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.id ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          targetedenergy: newArray,
        },
      },
    }));
  };

  const handleCheckboxChange = async (e, key, id) => {
    // console.log(newData.targetedenergy.find((idNew) => idNew == id));
    //id = energy (electricity, water, ...)

    console.log(e, key, id);
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId]["targetedusage"] == undefined &&
      (newArray[indexOfId]["targetedusage"] = []);

    console.log(indexOfId, newArray, newArray[indexOfId]["targetedusage"]);

    if (
      e.props.value.includes("all") &&
      targetedusageList[id].length !== newArray[indexOfId]["targetedusage"].length
    ) {
      newArray[indexOfId]["targetedusage"] = targetedusageList[id];
    } else if (e.props.value.includes("all")) {
      newArray[indexOfId]["targetedusage"] = [];
    } else if (
      newArray[indexOfId]["targetedusage"].find((n) => n.id == e.props.value) ==
      undefined
    ) {
      newArray[indexOfId]["targetedusage"].push({
        name: targetedusageList[id].find((n) => n.id == e.props.value).name,
        id: e.props.value,
      });
    } else {
      newArray[indexOfId]["targetedusage"] = newArray[indexOfId][
        "targetedusage"
      ].filter((x) => {
        return x.id != e.props.value;
      });
    }

    console.log(newArray);

    //setNewData(newArray);
    await setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          targetedenergy: newArray,
        },
      },
    }));
  };

  const editEnabled = (row) => async () => {
    editableRowId === row.id
      ? setEditableRowId(null)
      : setEditableRowId(row.id);
  };
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Selection des parois"
        noDataComponent="Aucun fluide selectionné"
        columns={columns}
        subHeader
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
       // dense
        {...gridState}
      />
    </>
  );
};

export default RTTargetFluid;
